"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useFloatingInIframe", {
    enumerable: true,
    get: function() {
        return useFloatingInIframe;
    }
});
const _react = require("react");
const _IframePageInfoContext = require("../contexts/IframePageInfoContext");
const _VisibleAreaContext = require("../contexts/VisibleAreaContext");
const _reactdom = require("@floating-ui/react-dom");
const useFloatingInIframe = (param)=>{
    let { placement, visible = true, fixedSize = false, pinToInitialPosition = false, offset: offsetInput = 0 } = param;
    const iframe = (0, _react.useContext)(_IframePageInfoContext.IframeResizerContext);
    const visibleAreaContext = (0, _react.useContext)(_VisibleAreaContext.VisibleAreaContext);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const initVisibleArea = (0, _react.useMemo)(()=>visibleAreaContext.visibleArea, []);
    const visibleArea = (0, _react.useMemo)(()=>pinToInitialPosition ? initVisibleArea : visibleAreaContext.visibleArea, [
        pinToInitialPosition,
        initVisibleArea,
        visibleAreaContext.visibleArea
    ]);
    (0, _react.useEffect)(()=>{
        if (fixedSize) {
            return ()=>undefined;
        }
        const origMethod = iframe.heightCalculationMethod;
        if (visible) {
            iframe.setHeightCalculationMethod("lowestElement");
        }
        return ()=>{
            iframe.setHeightCalculationMethod(origMethod);
        };
    }, [
        fixedSize,
        iframe,
        visible
    ]);
    const floating = (0, _reactdom.useFloating)({
        placement: placement === "bottom" ? "top" : "bottom",
        middleware: [
            (0, _reactdom.offset)((param)=>{
                let { rects } = param;
                return placement === "center" ? 0 - rects.floating.height / 2 : offsetInput;
            }),
            (0, _reactdom.shift)()
        ]
    });
    (0, _react.useLayoutEffect)(()=>{
        if (visibleArea != null) {
            const x = visibleArea.left + (visibleArea.right - visibleArea.left) / 2;
            const y = placement === "center" ? visibleArea.top + (visibleArea.bottom - visibleArea.top) / 2 : placement === "top" ? visibleArea.top : visibleArea.bottom;
            const rect = {
                top: y,
                bottom: y,
                y,
                left: x,
                right: x,
                x,
                width: 0,
                height: 0
            };
            floating.reference({
                getBoundingClientRect: ()=>rect
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        visibleArea,
        placement
    ]);
    const positioning = (0, _react.useMemo)(()=>{
        var _floating_y, _floating_x;
        return visibleArea == null ? undefined : {
            position: "absolute",
            top: "".concat((_floating_y = floating.y) !== null && _floating_y !== void 0 ? _floating_y : 0, "px"),
            left: "".concat((_floating_x = floating.x) !== null && _floating_x !== void 0 ? _floating_x : 0, "px")
        };
    }, [
        visibleArea,
        floating.x,
        floating.y
    ]);
    return {
        ...positioning,
        floating
    };
};

//# sourceMappingURL=useFloatingInIframe.js.map